const baseUrl = "https://apihenrypi.herokuapp.com/"

export const URL_SEARCH_BY_NAME = `${baseUrl}api/videogames?name=`

export const URL_GET_ALL_VIDEOGAME = `${baseUrl}api/videogames`

export const URL_GET_ALL_GENRES = `${baseUrl}api/genres`

export const URL_GET_DETAIL_VIDEOGAME = `${baseUrl}api/videogames/`

export const URL_POST_VIDEOGAME = `${baseUrl}api/videogames`